<template>
    <div class="border-t border-gray-400 mt-6 pt-6 sm:border-none md:mt-0 sm:pt-0">
        <div class="absolute -mt-1 md:-mt-3 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-equals"></i>
        </div>

        <form-row title="Balance Earnest Money"
            :no_border="true"
            class="sm:mt-4"
            label_class="ml-8 md:-mt-6 md:ml-0"
        >
            <div class="flex-1 sm:-mt-4 md:mt-0">
                <div class="flex flex-1 flex-col sm:flex-row sm:items-end">
                    <input-money
                        name="balance_earnest_money"
                        :value="value"
                        :read_only="true"
                    />

                    <input-text
                        class="mt-4 sm:mt-0 sm:ml-4 flex-1"
                        label="Source of funds"
                        name="balance_earnest_source"
                        :value="deal.balance_earnest_source"
                        :read_only="read_only"
                    />
                </div>

                <div class="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-end mt-4">
                    <div class="flex items-center">
                        <span class="text-sm text-gray-warm-800">
                            Due on
                        </span>

                        <div class="ml-3">
                            <input-date
                                name="balance_earnest_date_due"
                                v-model="balance_earnest_date_due"
                                @entered="dateEntered"
                                :read_only="read_only"
                            />
                        </div>
                    </div>

                    <div class="mt-4 sm:mt-0 flex items-center">
                        <span class="text-sm text-gray-warm-800 sm:ml-3">
                            OR
                        </span>

                        <input-text
                            class="ml-3 w-16"
                            name="balance_earnest_days_after"
                            v-model="balance_earnest_days_after"
                            :read_only="read_only"
                        />

                        <span class="text-sm text-gray-warm-800 leading-tight ml-3">
                            {{ $t('days after') }} <br>{{ $t('Attorney Review') }}
                        </span>
                    </div>
                </div>
            </div>
        </form-row>

        <div class="border-b border-gray-400 my-6"></div>
    </div>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        value: {},
        attorney: { default: () => ({}) },
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            balance_earnest_date_due: this.deal.balance_earnest_date_due,
            balance_earnest_days_after: this.deal.balance_earnest_days_after,
        }
    },

    computed: {
        attorney_review_date() {
            return this.attorney.attorney_review_date;
        },
        balance_earnest_date_due_from_period() {
            if (! this.attorney_review_date) {
                return;
            }

            if (this.isValidDate(this.attorney_review_date) && this.balance_earnest_days_after) {
                return dayjs(this.attorney_review_date.slice(0, 10))
                    .add({ day: this.balance_earnest_days_after })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.balance_earnest_days_after = null;
        },
    },

    watch: {
        balance_earnest_date_due_from_period(val) {
            if (val) {
                this.balance_earnest_date_due = val;
            }
        },
    },
}
</script>
